export const apiUrl = import.meta.env.VITE_API_URL ?? "http://localhost:8080";
export const version = import.meta.env.VITE_VERSION ?? "dev";

export const oidcClientId =
  import.meta.env.VITE_OIDC_CLIENT_ID ?? "dashboard-app";

export const contentWidth = "xl";
